import { agendaSlide, basicSlide, basicSlideWithLogo, orderedListSlide, preflightChecklist, tPrework, tPreworkWithLogo, tRecap } from './SLSprint00'
import { tQuizExpectations, tQuiz } from './SLSprint00'
import { completeDeck, tLab, tReviewDemoSchedule } from './SL00000Sprint00'
import { sprintDemosIntro, sprintDemos, demoAssignment } from './SLSprint00'
import { discussionBreakout, tMidtermExamExpectations, tExam } from './SLSprint00'


const checklistAnnouncementsPreworkAndAgenda = (pAaA, saals) => {
	const prework = () => { return tPreworkWithLogo('Prework For Today', pAaA.prework, saals.sprint, saals.activityList) }
	const announcements = () => { return tPreworkWithLogo('Announcements', pAaA.announcements, saals.sprint )}
	const agenda = () => { return agendaSlide( pAaA.agenda) }

	return [ preflightChecklist, prework, announcements, agenda ]
}

const preworkNextRecapAndEnd = (pAaA, pAaANext, saals) => {
	const preworkNext = () => { return tPrework('Prework For Next Class', pAaANext.prework, saals.sprint, saals.activityList) }
	const recap = () => { return tRecap(pAaA.agenda) }
	const end = () => { return basicSlideWithLogo('End of Session', [ 'Thank you for your time and participation.']) }

	return [ preworkNext, recap, end ]
}

const makeSlideDeck = (pAaA, pAaANext, saals, sessionSpecificSlides) => {
	return checklistAnnouncementsPreworkAndAgenda(pAaA, saals)
		.concat( sessionSpecificSlides )
		.concat( preworkNextRecapAndEnd(pAaA, pAaANext, saals) )
}

export const insertInto = (destinationDeck, sourceDeck, atDestinationIndex) => {
	return destinationDeck.slice(0, atDestinationIndex)
		.concat(sourceDeck)
		.concat(destinationDeck.slice(atDestinationIndex, destinationDeck.length))
}

export const xyz_n_1of4_PAaA = (sprint) => {
	return {
		'prework':[ 
			'Everything due Sunday!', '',
			`Be prepared for Sprint Planning` ],
		'announcements':[ 
			`Sprint ${sprint} starts now` ],
		'agenda':[ 
			`Sprint ${sprint} Planning`,
			`Sprint ${sprint} Planning Breakout`,
			'Review Demos and Demo Schedule',
			'Prework for Next Class' ]
	}
}

export const xyz_n_1of4 = (pAaA, pAaANext, saals, sprintPlanningExpectations) => {
	const sprintPlanningExpectationsDefault = () => {
		return orderedListSlide('Sprint Planning', `Sprint ${saals.sprint} Expectations:`, [
			'Similar to other sprints with Discussion, Quiz, Lab, and Reflection',
			`Similar in that we will have two weeks to complete all sprint ${saals.sprint} assignments`,
			`Similar in that  we will work on Discussion Board ${saals.sprint} as a scrum team in class on Thursday`,
			`Similar in that we will have sprint ${saals.sprint-1} Demos and Retrospectives on Thursday`,
			'Similar in that we will meet in-person during our normal class times' ])
	}
	const getPAaA = () => {
		if (pAaA !== null) { return pAaA }
		else { return xyz_n_1of4_PAaA(saals.sprint) }
	}
	const getPAaANext = () => {
		const completeThroughDefault = 5
		if (pAaANext !== null) { 
			return pAaANext 
		}
		else { 
			return xyz_n_2of4_PAaA(completeThroughDefault, saals.sprint) }
	}
	const getPlanningExpectations = () => {
		if (sprintPlanningExpectations !== null) { return sprintPlanningExpectations() }
		else { return sprintPlanningExpectationsDefault() }
	}
	const prework = () => { return tPreworkWithLogo('Prework For Today', getPAaA().prework, saals.sprint-1, saals.activityListPrevious) }
	const announcements = () => { return tPreworkWithLogo('Announcements', getPAaA().announcements, saals.sprint )}
	const agenda = () => { return agendaSlide( getPAaA().agenda) }
	const planningExpectations = () => { return getPlanningExpectations() }

	const activitiesReview = () => {
		return basicSlide('Activity List and Assignments Review', [
			'Let’s open our Blackboard shell and review the activity list and assignments together.' ])
	}
	const planningBreakout = () => {
		return orderedListSlide('Sprint Planning Scrum Team Breakout', 'As a scrum team:', [
			`Review sprint ${saals.sprint} activity list & assignments in detail`,
				'Discuss and identify questions/concerns',
				'Scrum master report out by sharing scrum team’s top 2 or 3 questions/concerns',
				'How will you get your Scrum Team Discord server set up before class on Thursday?' ])
	}
	const preworkNext = () => { return tPrework('Prework For Next Class', getPAaANext().prework, saals.sprint, saals.activityList) }
	const recap = () => { return tRecap(getPAaA().agenda) }
	const end = () => { return basicSlideWithLogo('End of Session', [ 'Thank you for your time and participation.']) }

	return [ preflightChecklist, prework, announcements, agenda, planningExpectations, activitiesReview, planningBreakout,
		preworkNext, recap, end ]
}

export const xyz_n_2of4_PAaA = (completeThrough, sprint) => {
	const preworkAnnouncementsAndAgenda = {
	'prework':[
		`Complete through activity ${completeThrough} prior to next class`, '',
		'Be prepared for Demos and Retrospectives',
		`Be prepared for Discussion ${sprint} with your scrum team`,
	],
	'announcements':[
		'Any announcements?' ],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		`Sprint ${sprint} Planning Q&A`,
		`Discussion Board ${sprint} as a scrum team`,
		'Prework for Next Class',
		'Lab' ],
	}

	return preworkAnnouncementsAndAgenda
}

export const xyz_n_2of4 = (pAaA, pAaANext, saals, metricsSubmissionPercentage, retrospective ) => {
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(pAaA, saals)
	const metrics = () => {
		return basicSlide(`Sprint ${saals.sprint-1} Metrics`, [
			`Let’s take a minute and review our Sprint ${saals.sprint-1} Submission Percentage class metric.` ])
	}
	const retrospectiveBreakout = () => {
		return orderedListSlide('Breakout Session for Team Retrospective', 
			'As a scrum team consider:', [
			`How does your team feel about sprint ${saals.sprint-1} now that it is over`,
			`What could be done to make sprint ${saals.sprint-1} or the class overall better or more manageable`,
			'What improvements should we make as a class, team, or individual going forward' ])
	}
	const sprintPlanningQA = () => {
		return orderedListSlide(`Sprint ${saals.sprint} Planning Q&A`, 
			`Are you clear on what’s expected in sprint ${saals.sprint}?`, [])
	}
	const discussionNBreakout = () => { return discussionBreakout(saals.sprint) } 
	const preworkNext = () => { return tPrework('Prework For Next Class', pAaANext.prework, saals.sprint, saals.activityList) }
	const recap = () => { return tRecap(pAaA.agenda)}

	return completeDeck(slideDeck, [ tReviewDemoSchedule, sprintDemosIntro, sprintDemos, demoAssignment, metrics, 
		metricsSubmissionPercentage, retrospective, retrospectiveBreakout, sprintPlanningQA, discussionNBreakout, 
		preworkNext, tLab, recap ])
}


export const xyz_n_3of4_PAaA = (completeThrough, sprint, breakoutName) => {
	const preworkAnnouncementsAndAgenda = {
		'prework':[
			`Make your initial Discussion ${sprint} post`,
			`Complete through activity ${completeThrough}`, 
			`Be prepared for ${breakoutName} Breakout`,
			`Be prepared for Quiz ${sprint}` ],
		'announcements':[
			`Your initial Discussion ${sprint} post was due two days ago`,
			`All sprint ${sprint} activities and assignments due Sunday!` ],
		'agenda':[
			'Sprint Progress Polling',
			`${breakoutName} Breakout`,
			'Lab',
			'Prework for Next Class',
			`Quiz ${sprint}` ]
	}
	return preworkAnnouncementsAndAgenda
}
export const xyz_n_3of4 = (pAaA, pAaANext, saals, breakoutSlide) => { 
	const poll = () => { return tPrework('Sprint Progress Polling', pAaA.prework, saals.sprint, saals.activityList) }
	const preworkNext = () => { return tPrework('Prework For Next Class', pAaANext.prework, saals.sprint, saals.activityList) }
	const quiz = () => { return tQuiz(saals.sprint) }
	const recap = () => { return tRecap(pAaA.agenda.slice(0)) }

	const slideDeck =  checklistAnnouncementsPreworkAndAgenda(pAaA, saals)
	return completeDeck(slideDeck, [ poll, breakoutSlide, tLab, preworkNext, recap, tQuizExpectations, quiz ])
}

export const xyz_n_4of4_PAaA = (completeThrough, sprint) => {
	const preworkAnnouncementsAndAgenda = {
		'prework': [
			`Complete through activity ${completeThrough}`, '',
			'Be prepared for Lab'],
		'announcements':[
			`All sprint ${sprint} assignments are due Sunday!`],
		'agenda':[
			`Final sprint ${sprint} activity list and assignment Q&A`,
			'Prework for Next Class', 
			'Lab']
	}
	return preworkAnnouncementsAndAgenda
}
export const xyz_n_4of4 = (pAaA, pAaANext, saals) => {
	const getPAaANext = () => {
		if (pAaANext !== null) { return pAaANext }
		else { return xyz_n_1of4_PAaA(saals.sprint+1) }
	}

	return makeSlideDeck(pAaA, getPAaANext(), saals, [ tLab ])
}

export const xyz_n_MidtermExam_PAaA = (sprint) => {
	const preworkAnnouncementsAndAgenda = {
	'prework':[
		'**Be prepared to take you midterm exam in person',
		'Be prepared for Lab' ],
	'announcements':[
		`All sprint ${sprint} assignments due Sunday!` ],
	'agenda':[
		'Midterm Exam',
		'Lab' ]
	}

	return preworkAnnouncementsAndAgenda
}

export const xyz_n_MidtermExam = (pAaA, pAaANext, saals) => {
	const preworkNext = () => { return tPrework('Prework For Next Class', pAaANext.prework, saals.sprint, saals.activityList) }
	const recap = () => { return tRecap(pAaA.agenda.slice(0)) }

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(pAaA, saals.sprint, saals.activityList)

	return completeDeck(slideDeck, [ preworkNext, tMidtermExamExpectations, tExam, tLab, recap ])
}

export const xyz_n_DemosAndRetrospective = (pAaA, pAaANext, saals, submissionPercentage, retrospective) => { 
	const poll = () => { return tPrework('Sprint Progress Polling', pAaA.prework, saals.sprint, saals.activityList) }
	const preworkNext = () => { return tPrework('Prework For Next Class', pAaANext.prework, saals.sprint, saals.activityList) }
	const recap = () => { return tRecap(pAaA.agenda.slice(0)) }

	const slideDeck =  checklistAnnouncementsPreworkAndAgenda(pAaA, saals.sprint, saals.activityList)

	console.log('Error: Depreciated. Use xyz_n_2of4 instead')
	return completeDeck(slideDeck, [ poll, sprintDemosIntro, sprintDemos, demoAssignment,  submissionPercentage, retrospective, 
		preworkNext, tLab, recap ])
}

export const xyz_7_FinalExam = (pAaA, pAaANext, saals) => { 
	const poll = () => { return tPrework('Sprint Progress Polling', pAaA.prework, saals.sprint, saals.activityList) }
	const finalExamExpectations = () => {
		return orderedListSlide('Exam Expectations', 
				'Exam Expectations include:', [
				'No notes, internet searches, of other applications',
				'Only one browser tabs with your midterm exam open',
				'The exam is an individual assignment so asking others would be inappropriate',
				'Your final graded attempt must be submitted by the end of class',
				'Your final attempt with be the grade your receive for the exam and you will not be able to take the exam later' ])
	}
	const classProjectPresentations = () => {
		return orderedListSlide('Class Project Presentation Schedule and Expectations ', 
			'Review Class Project Presentation Dates/Times and Expectations:', [
			'Dates and times... in person attendance is required',
			'Presentation Expectations' ])
	}
	const preworkNext = () => { return tPrework('Prework For Next Class', pAaANext.prework, saals.sprint, saals.activityList) }
	const recap = () => { return tRecap(pAaA.agenda.slice(0)) }

	const slideDeck =  checklistAnnouncementsPreworkAndAgenda(pAaA, saals.sprint, saals.activityList)
	return completeDeck(slideDeck, [ poll, classProjectPresentations, finalExamExpectations, 
		tExam, preworkNext, tLab, recap ])
}

export const xyz_7_LastRegularSession = (pAaA, pAaANext, saals) => {
	const poll = () => { return tPrework('Sprint Progress Polling', pAaA.prework, saals.sprint, saals.activityList) }
	const classProjectPresentations = () => {
		return orderedListSlide('Class Project Presentation Schedule and Expectations ', 
			'Review Class Project Presentation Dates/Times and Expectations:', [
			'Dates and times... in person attendance is required',
			'Presentation Expectations' ])
	}
	const preworkNext = () => { return tPrework('Prework For Next Class', pAaANext.prework, saals.sprint, saals.activityList) }
	const recap = () => { return tRecap(pAaA.agenda.slice(0)) }
	const workingWithIndia = () => {
		return basicSlide('Globalization and Working with India', [
			'Global teams continue to becoming increasingly common in today’s business environment', '',
			'Are there similarities today with AI Assisted coding to what happened previously as we moved to global teams?' ])
	}

	const slideDeck =  checklistAnnouncementsPreworkAndAgenda(pAaA, saals)
	return completeDeck(slideDeck, [ poll, classProjectPresentations, preworkNext, tLab, workingWithIndia, recap ])
}

export const productPresentation = () => {
	return orderedListSlide(
		'Class Product Presentations', 
		`Product Overview (less than 5 minutes) followed by each team member providing a:`, [
		'Demonstration of product functionality that they are proud of personally delivering running in production',
		'Description of how the functionality benefits customers / users',
		'Review of the related source code' ])
}

export const xyz_8_ClassProductPresentations = (pAaA, pAaANext, saals, productPresentation) => { 
	const nextSteps = () => { return tPrework('Next Steps', [ 'Everything is due Wednesday!' ], saals.sprint, saals.activityList) }
	const finalComments = () => {
		return orderedListSlide('Thank you!', '', [
			'Thank you for making this a wonderful experience for me',
			'Don’t hesitate to reach out in the future',
			'Hope to see you in a future class', 
			'Very nice work! I am impressed with what you have accomplished.' ])
	}
	
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(xyz_8_1of1_PAaA, saals.sprint, saals.activityList)
	return completeDeck(slideDeck, [ productPresentation, nextSteps, finalComments ]) 
}

export const xyz_8_1of1_PAaA = {
	'prework':[
		'Be prepared for your Class Project Presentations' ],
	'announcements':[ 
		'Please consider taking time to complete your course evaluation' ],
	'agenda':[
		'Class Product Presentations',
		'Thank you!' ] 
}